import * as z from "zod";

export const stripeAccountSettingsSchema = z
  .object({
    statementDescriptor: z.string().max(22).optional(),
    payoutSchedule: z
      .object({
        interval: z.enum(["weekly", "monthly"]).default("monthly"),
        weeklyAnchor: z
          .enum([
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday",
          ])
          .optional(),
        monthlyAnchor: z.number().min(1).max(31).optional(),
      })
      .optional(),
  })
  .describe("StripeAccountSettings");

export const stripeCheckoutSettingsSchema = z
  .object({
    automaticTax: z.boolean().default(false),
    allowedCountries: z.array(z.string()).nullish(), // null means no collection
    allowPromotionCodes: z.boolean().default(false),
  })
  .describe("StripeCheckoutSettings");

export const stripeConnectConfigSchema = z
  .object({
    id: z.uuid(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    deletedAt: z.coerce.date().nullish(),
    stripeConnectAccountId: z.string(),
    onboardingComplete: z.boolean(),
    chargesEnabled: z.boolean(),
    payoutsEnabled: z.boolean(),
    detailsSubmitted: z.boolean(),
    requirements: z.any().optional(), // Stripe requirements object
    integrationId: z.uuid(),
    accountSettings: stripeAccountSettingsSchema.nullish(),
    checkoutSettings: stripeCheckoutSettingsSchema.nullish(),
  })
  .describe("StripeConnectConfig");
